<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header">
            <span>{{ $t("global.controlsandinterfaces") }}</span>
          </div>
          <div class="body">
            <div class="row">
              <div v-for="kachel in kacheln" :key="kachel.kennung" class="col-xl-4 col-lg-6 col-md-12">
                <div class="tile-frame left-aligned h-1">
                  <router-link :to="kachel.link">
                    <div class="tile bg-light-blue inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon :icon="kachel.symbol" fixed-width transform="shrink-3" />
                      </div>
                      <div class="title">
                        <div>{{ kachel.bezeichnung }}</div>
                      </div>
                      <div class="informations">
                        <div class="row justify-content-end">
                          <div v-if="kachel.letzterLaufAm" class="col-6">
                            <div class="information fs-14" :title="$t('global.lastrun')">{{ zeitText(kachel.letzterLaufAm) }}</div>
                          </div>
                          <div v-if="kachel.aufmerksamkeit > 0" class="col-3">
                            <div class="information aufmerksamkeit fs-14" :title="$t('global.needsattention')">{{ kachel.aufmerksamkeit }}</div>
                          </div>
                          <div v-if="kachel.fehler > 0" class="col-3">
                            <div class="information fehler fs-14" :title="$t('global.error')">{{ kachel.fehler }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";

/** Kachel Protokoll, immer zuletzt (9.2); die Bezeichnung übersetzt kacheln */
const PROTOKOLL = { kennung: "protokoll", bezeichnung: "Protokoll", symbol: "fa-regular fa-list-check", seite: "einstellungen-protokoll" };

export default {
  name: "SteuerungenKategorie",
  data() {
    return {
      ablaeufe: [],
    };
  },
  computed: {
    /**
     * Je Ablauf mit Seite eine Kachel, in der Reihenfolge des Servers (nach Art und Bezeichnung), zuletzt die
     * Kachel Protokoll mit dem jüngsten Lauf aller Abläufe und den Summen
     */
    kacheln() {
      const mitSeite = this.ablaeufe
        .filter((a) => a.seite)
        .map((a) => ({ ...a, link: { name: a.seite } }));
      const protokoll = {
        ...PROTOKOLL,
        bezeichnung: this.$t("global.log"),
        link: { name: PROTOKOLL.seite },
        letzterLaufAm: this.juengsterLaufAm,
        aufmerksamkeit: this.ablaeufe.reduce((summe, a) => summe + a.aufmerksamkeit, 0),
        fehler: this.ablaeufe.reduce((summe, a) => summe + a.fehler, 0),
      };
      return [...mitSeite, protokoll];
    },
    /** Der jüngste letzterLaufAm aller Abläufe; dd.MM.yyyy HH:mm wird zum Vergleichen umgestellt */
    juengsterLaufAm() {
      const sortierbar = (t) => t.replace(/^(\d{2})\.(\d{2})\.(\d{4}) (.*)$/, "$3$2$1 $4");
      return this.ablaeufe
        .map((a) => a.letzterLaufAm)
        .filter((t) => t)
        .reduce((juengster, t) => (!juengster || sortierbar(t) > sortierbar(juengster) ? t : juengster), null);
    },
  },
  created() {
    this.laden();
  },
  methods: {
    laden() {
      AppApi.get("lauf/ablaeufe/")
        .then((response) => {
          this.ablaeufe = response.data;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        });
    },
    /**
     * Uhrzeit des letzten Laufs, bei einem Lauf vor heute das Datum (9.2).
     * letzterLaufAm kommt vom Server als „dd.MM.yyyy HH:mm“.
     */
    zeitText(letzterLaufAm) {
      const vonHeute = letzterLaufAm.startsWith(new Date().toGermanDateString());
      const [datum, uhrzeit] = letzterLaufAm.split(" ");
      if (vonHeute) {
        return uhrzeit;
      } else {
        return datum;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors";
@import "~@/scss/variables";

/*
 * Die eine Farbe vom Board. bg-light-blue ist auch eine Theme-Farbe von Bootstrap ($very-light-blue mit
 * !important) und überdeckt die Kachelfarbe aus $tile-colors; ohne diese Regel wäre die Kachel fast weiss und
 * das Uhrzeit-Kästchen beim Darüberfahren nicht mehr zu sehen.
 */
$kachelfarbe: map-get($tile-colors, "light-blue");

.tile.bg-light-blue {
  background-color: $kachelfarbe !important;

  &:hover {
    background-color: lighten($kachelfarbe, 10%) !important;
  }
}

/*
 * Farbregel 9.1: Bernstein nur für „braucht Aufmerksamkeit“, Rot nur für Fehler. Der Selektor folgt dem aus
 * scss/components/_tile.scss, damit er die Hintergrundfarbe der Kachel auch beim Darüberfahren überschreibt.
 */
.tile-container .tile-categorie-frame .tile-categorie .body .tile-frame .tile.bg-light-blue .informations .information {
  border-radius: 3px;
  font-weight: 700;

  &.aufmerksamkeit {
    background-color: $light-orange;
    color: $orange;
  }
  &.fehler {
    background-color: $very-light-red;
    color: $red;
  }
}
</style>
